/** Hindi: moving to a new city for work, and the city guide. */
export const landing = {
    "landing.title": "नए शहर में जा रहे हैं",
    "landing.draft": "सार्वजनिक स्रोतों से बना ड्राफ़्ट। अभी किसी यूनियन ने जाँचा नहीं है।",
    "landing.loading": "गाइड आ रही है…",
    "landing.no_guide": "गाइड डाउनलोड नहीं हो सकी। एक बार इंटरनेट से जुड़ें, फिर यह इसी फ़ोन पर रहेगी।",
    "landing.offline": "इंटरनेट नहीं है: {date} को इस फ़ोन पर रखी गाइड दिख रही है।",
    "landing.start_title": "आप कहाँ जा रहे हैं?",
    "landing.city": "शहर",
    "landing.city_only": "अभी सिर्फ़ वही शहर हैं जिनकी गाइड बनी है।",
    "landing.city.bengaluru": "बेंगलुरु",
    "landing.arrival": "आप किस दिन पहुँचेंगे?",
    "landing.trade": "आपका काम",
    "landing.start": "गाइड शुरू करें",
    "landing.problem_city": "शहर चुनें।",
    "landing.problem_arrival": "पहुँचने का दिन चुनें।",
    "landing.problem_trade": "अपना काम चुनें।",
    "landing.arriving": "{city} · {date} को पहुँचना · {trade}",
    "landing.step.planning": "तैयारी",
    "landing.step.travelling": "सफ़र",
    "landing.step.arrived": "पहुँच गए",
    "landing.step.housed": "रहने की जगह",
    "landing.step.documented": "कागज़",
    "landing.step.registered": "रजिस्ट्रेशन",
    "landing.step.working": "काम",
    "landing.step.settled": "बस गए",
    "landing.steps": "जाने के क़दम",
    "landing.step_of": "क़दम {n} / {total}",
    "landing.done_count": "{total} में से {done} हो गए",
    "landing.next": "अगला क़दम: {step}",
    "landing.back_step": "वापस: {step}",
    "landing.ticked_app": "ऐप ने टिक किया: शहर में एक काम जिस पर आप दोनों ने साइन किया।",
    "landing.fixed_money": "पहले महीने के लिए पैसे अलग रखें (पैसों का हिसाब देखें)",
    "landing.fixed_documents": "आधार कार्ड, अपनी दो फ़ोटो और दूसरे पहचान पत्रों की कॉपी साथ रखें",
    "landing.fixed_tell_home": "घर पर किसी को बताएँ कि आप कहाँ रहेंगे और कब पहुँचेंगे",
    "landing.fixed_share_trip": "अपनी ट्रेन या बस की जानकारी घर पर किसी को भेजें",
    "landing.fixed_save_address": "जहाँ रह रहे हैं उसका पता लिख लें",
    "landing.fixed_rent_receipt": "किराए का लिखित एग्रीमेंट या रसीद माँगें",
    "landing.fixed_no_deposit_unseen": "बिना देखे किसी कमरे का डिपॉज़िट कभी न दें",
    "landing.fixed_copies": "अपने कागज़ों की फ़ोटो फ़ोन में रखें",
    "landing.fixed_card_area": "अपने कार्ड में नया इलाक़ा डालें",
    "landing.fixed_first_job": "नए शहर में पहला काम पाएँ",
    "landing.fixed_help_next": "शहर में नए आए किसी और की मदद करें",
    "landing.read": "गाइड में क्या लिखा है, पढ़ें",
    "landing.sources": "यह जानकारी कहाँ से है",
    "landing.source_read": "{title} ({date} को पढ़ा)",
    "landing.as_written": "अंग्रेज़ी में, जैसा लिखा है",
    "landing.copy_say": "क्या कहना है, कॉपी करें",
    "landing.copied": "कॉपी हो गया। काउंटर पर दिखाएँ या पढ़कर सुनाएँ।",
    "landing.ask_title": "गाइड से पूछें",
    "landing.ask_placeholder": "रहने की जगह कहाँ मिलेगी? बैंक खाता कैसे खुलेगा?",
    "landing.ask_hint": "जवाब गाइड के अपने शब्दों में हैं, साथ में यह कि हर बात कहाँ से आई।",
    "landing.you_asked": "आपने पूछा: {question}",
    "landing.no_answer": "गाइड में अभी इस पर कुछ नहीं है।",
    "landing.no_answer_next": "नीचे दिए किसी नंबर पर फ़ोन करें, या शहर जानने वाले किसी से पूछें।",
    "landing.by_model": "इस फ़ोन के मॉडल ने गाइड के शीर्षकों में से यह हिस्सा चुना।",
    "landing.helplines": "ये नंबर सेव करें",
    "landing.call": "{name} को {number} पर फ़ोन करें",
    "landing.places": "जगहें",
    "landing.places_note": "सार्वजनिक स्रोतों से ली गई सूची, किसी ने गारंटी नहीं दी। जाने से पहले फ़ोन करें।",
    "landing.kind.housing": "रहने की जगह",
    "landing.kind.union": "यूनियन",
    "landing.kind.office": "दफ़्तर",
    "landing.source": "स्रोत",
    "landing.register_title": "रजिस्ट्रेशन",
    "landing.register_note": "ऐप आपके लिए कोई फ़ॉर्म नहीं भरता, न भेजता है। सरकारी पेज खोलें और ख़ुद करें।",
    "landing.cash_title": "पहले महीने का ख़र्च",
    "landing.cash_note": "ड्राफ़्ट गाइड से {from} से {to} तक का मोटा अंदाज़ा। सिर्फ़ गाइड में लिखे ख़र्च जोड़े गए हैं।",
    "landing.cash_total": "लगभग {amount}",
    "landing.cash_times": "{amount} × {times} = {total}",
    "landing.free": "मुफ़्त",
    "landing.not_known": "अभी पता नहीं",
    "landing.unchecked": "अभी जाँचा नहीं गया",
    "landing.unchecked_note": "जो बातें गाइड लिखने वाले पक्की नहीं कर सके। भरोसा करने से पहले यूनियन से पूछें या फ़ोन करें।",
    "landing.mentor": "मेंटर ढूँढें",
    "landing.remove": "यह सफ़र हटाएँ",
    "landing.remove_confirm": "यह सफ़र इस फ़ोन से हटाएँ? आपके टिक भी हट जाएँगे।",
    "landing.remove_yes": "हटाएँ",
    "landing.keep": "रहने दें",
};
//# sourceMappingURL=landing.js.map